export class MultiselectItem{
    id:string;
  }